export default {
      id: "edit-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "sprite.svg#edit",
      toString: function () {
        return this.url;
      }
    }